import React from "react";
import { Typography, Grid, Box } from "@mui/material";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";
import ReviewModal from "./ReviewModal";
import { useAuth } from "../../context/AuthContext";
import RateReviewIcon from "@mui/icons-material/RateReview";
import { HashLink } from "react-router-hash-link";
import { useLocation } from "react-router-dom";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useTranslation } from "react-i18next";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}
const Review = ({
  id,
  rating,
  name,
  title,
  review,
  imgs,
  uid,
  productId,
  link,
  productName,
  created,
  admin,
}) => {
  const { currentUser } = useAuth();
  const { t, i18n } = useTranslation();

  console.log("====", { id, rating, name, title, review, imgs, uid });

  let query2 = useQuery();
  let edit_url;

  if (query2.get("name")) {
    let productName = query2.get("name");
    let link = query2.get("link");
    let productIdFromURL = query2.get("productId");
    edit_url = `/edit-a-review?productId=${productIdFromURL}&name=${productName}&link=${link}&id=${id}`;
    console.log(edit_url);
  } else {
    edit_url = `/edit-a-review?productId=${productId}&name=${productName}&link=${link}&id=${id}`;
    console.log(edit_url);
  }

  return (
    <Grid
      container
      sx={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        paddingBottom: "20px",
        paddingTop: "20px",
      }}
    >
      <Grid item md={12} sx={{ display: "flex", alignItems: "center" }}>
        <Rating
          name="text-feedback"
          value={rating}
          readOnly
          precision={0.5}
          emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
          sx={{ paddingRight: "5px", position: "relative", top: "-3px" }}
        />
        <Box sx={{ color: "lightgray" }}>/</Box>
        <div style={{ fontSize: "15px", color: "gray", paddingLeft: "5px" }}>
          <img src="/img/user4.png" width="15" height="15" />{" "}
          {name.substring(0, 4) + "****"}{" "}
        </div>

        <Box sx={{ color: "lightgray" }}>/</Box>
        <Typography sx={{ paddingLeft: "5px", fontWeight: "bold" }}>
          {title}
        </Typography>

        {/* <div
          style={{
            position: "relative",
            top: "+2px",

            color: "#757575",
          }}
        >
          <span style={{ fontSize: "11px" }}>
            <CheckCircleOutlineIcon
              sx={{
                fontSize: "13px",
                color: "#a1a1a1",
                position: "relative",
                top: "+2px",
                paddingLeft: "5px",
              }}
            />
          </span>
          {name.substring(0, 4) + "****"}
        </div>
        <Typography
          sx={{
            paddingLeft: "5px",
            fontWeight: "bold",
            position: "relative",
            top: "+2px",
          }}
        >
          {title}
        </Typography> */}
      </Grid>

      <Grid item md={12}>
        <Box sx={{ color: "#9e9e9e", paddingTop: "7px", fontSize: "13px" }}>
          작성일:{" "}
          {created &&
            created?.toDate().toLocaleDateString("fr-CA", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            })}{" "}
        </Box>
        <Typography sx={{ paddingTop: "7px" }}>{review}</Typography>
        {admin && (
          <Box sx={{ backgroundColor: "#f5f5f5", ml: 10, p: 2, mt: "3px" }}>
            <span style={{ color: "#9e9e9e" }}>
              {t("Response From Heslet")}
            </span>
            : {admin}
          </Box>
        )}
        <Box sx={{ pt: 2 }}>
          <ReviewModal
            rating={rating}
            imgs={imgs}
            title={title}
            review={review}
            name={name}
          />
        </Box>
      </Grid>
      {uid === currentUser?.uid ? (
        <Grid
          item
          md={12}
          sx={{
            pt: 1,
            textDecoration: "underline",
            color: "#f3756d",
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            fontSize: "13px",
          }}
        >
          <HashLink to={edit_url + "#top"}>
            <DriveFileRenameOutlineOutlinedIcon
              sx={{
                fontSize: "13px",
                mr: 1,
                position: "relative",
                top: "+2px",
                color: "gray",
              }}
            />
            {t("Edit/Delete my review")}
          </HashLink>
        </Grid>
      ) : null}
    </Grid>
  );
};

export default Review;
